/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import { useContext, useEffect } from "react";
import { FitinsurAPI, MessageCenter } from "../utils/src/index";
import { GlobalAuthContext } from "../store/context";

export default function useBackgroundOsndImportService() {
  const authContext = useContext(GlobalAuthContext);
  const fitinsur = new FitinsurAPI();
  const mc = new MessageCenter();

  useEffect(() => {
    setInterval(async () => {
      const processingFileId = localStorage.getItem("processing-file");
      if (!processingFileId) return;

      try {
        fitinsur.setAuthToken(authContext.token);
        const response = await fitinsur
          .requestProcessReportFileStatus(processingFileId)
          .then((response) => response.json());
        if (response.ret_code !== 200 || response.ret_value.processing) return;

        localStorage.removeItem("processing-file");
        mc.success("Your file was processed successfully!");
      } catch (e) {}
    }, 5000);
  }, [authContext.token, mc, fitinsur]);
}
